import { render, staticRenderFns } from "./OrderCreateStep3.vue?vue&type=template&id=63bdb70a&"
import script from "./OrderCreateStep3.vue?vue&type=script&lang=js&"
export * from "./OrderCreateStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports